
export const APPIDS = {
    APP_ID_ZUORA : 12,
    APP_ID_SUBARU : 17,
    APP_ID_WOVENCORE : 22,
    APP_ID_CVS : 49
};